<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
</style>

<script>
    // export default {
    //     data() {
    //         return {
    //             form: {
    //                 zipcode: '',
    //                 housing: 0,
    //                 area: 0,
    //                 energy: '',
    //                 model: '',
    //                 brand: 0,
    //                 install: '',
    //                 usage: '',
    //                 contractor: false,
    //                 residence: 0,
    //                 dwellers: 0
    //             }
    //         }
    //     }
    // }
</script>
<script setup>
import {ref} from 'vue'
const form = ref({zipcode: '',housing: 0,area: 0,energy: '',model: '',brand: 0,install: '',usage: '',contractor: false,residence: 0, dwellers: 0});
</script>
